import type { AnimatedIconName } from 'components/AnimatedIcon/AnimatedIconName';
import type { CmsApiReactionType } from 'modules/cms/api/reactions/types/CmsApiReactionType';

export function getAnimatedIconNameForReactionType(
  reactionType: CmsApiReactionType,
): AnimatedIconName {
  return reactionType.toLowerCase() as Lowercase<CmsApiReactionType>;
}
